import React from 'react';

import { Button, Box, Typography, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { FlorencePAGES } from '../../../common/components/tfa-auth/constants/pages';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const NoSubscriptionPopup: React.FC<Props> = ({ open, onClose, onConfirm }) => {
  const navigate = useNavigate();

  const redirectToSubscriptionScreen = () => {
    navigate(FlorencePAGES.subscriptions);
  };

  const onCloseEvent = (
    event: never,
    reason: 'backdropClick' | 'escapeKeyDown'
  ) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onClose();
  };

  return (
    <Modal open={open} onClose={onCloseEvent}>
      <Box sx={modalStyle}>
        <div>
          <Typography sx={{ mt: 1, mb: 1 }} fontWeight={600} fontSize={18}>
            You do not have an active subscription plan.
          </Typography>
          <Typography color='gray'>
            Please purchase a subscription to continue using the app.
          </Typography>
          <Button
            onClick={onConfirm}
            variant='contained'
            color='error'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>OK, got it</Typography>
          </Button>
          <Button
            onClick={() => redirectToSubscriptionScreen()}
            variant='contained'
            color='secondary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '10px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>Redirect me</Typography>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default NoSubscriptionPopup;
